import React from "react";
import { Turf, turfNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";
import AutoComplete from "../AutoComplete";

const IlluminationAutocomplete = (props:any) => {
    const { selectedValues, manageSelect, isReadOnly } = props;
    const [t] = useTranslation();
    const options = [
      { value: '', name: t('DC_NONE') },
      { value: '100', name: '100' },
      { value: '200', name: '200' },
      { value: '300', name: '300' },
      { value: '400', name: '400' },
      { value: '500', name: '500' },
      { value: '600', name: '600' },
      { value: '700', name: '700' },
      { value: '800', name: '800' },
      { value: '900', name: '900' },
      { value: '1000', name: '1000' },
      { value: '1100', name: '1100' },
      { value: '1200', name: '1200' },
      { value: '1300', name: '1300' },
      { value: '1400', name: '1400' },
      { value: '1500', name: '1500' },
    ];

    const manageIlluminationSelect = (d:any) => {
      let tempIlluminations = [];
      const index = selectedValues.findIndex((item:any) => item == d.value);
      if(index !== -1) {
        tempIlluminations = selectedValues.filter((item:any) => item != d.value);
      } else {
        tempIlluminations = [...selectedValues, d.value];
      }
      manageSelect(tempIlluminations);
    }

    return (
        <>
            <AutoComplete 
            options={options}
            selectedValues={selectedValues}
            handleMenuClick={manageIlluminationSelect} 
            label={t('')}
            clickReset={() => {manageSelect([])}}
            isMultiple={true}
            variant={'standard'}
            isReadOnly={isReadOnly}
            />
        </>
    );
}

export default IlluminationAutocomplete;